<template>
  <div class="cdg">
    <CalcPanel titulo="Desplazamiento y descuentos" :pista="pistaKm">
      <div class="cdn-grid">
        <div class="cdn-f"><label for="cdn-km">Km ida + vuelta</label><div class="cdn-unit"><input id="cdn-km" type="number" min="0" step="5" :value="form.km" :disabled="!!form.mismo" @input="num('km', $event)"><span>km</span></div></div>
        <div class="cdn-f"><label for="cdn-dto">Descuento 1ª</label><div class="cdn-unit"><input id="cdn-dto" type="number" min="0" max="99" step="5" :value="pct(form.dto)" @input="dto('dto', $event)"><span>%</span></div></div>
        <div class="cdn-f" v-if="tiene2a"><label for="cdn-dto2">Descuento 2ª</label><div class="cdn-unit"><input id="cdn-dto2" type="number" min="0" max="99" step="5" :value="pct(form.dto2)" @input="dto('dto2', $event)"><span>%</span></div></div>
      </div>
      <div class="cdn-checks" style="margin-top:10px">
        <label class="cdn-chk" :class="{ on: !!form.mismo }"><input type="checkbox" :checked="!!form.mismo" @change="$emit('set', 'mismo', $event.target.checked)">Mismo emplazamiento</label>
        <label class="cdn-chk" :class="{ on: !!form.recargoFS }"><input type="checkbox" :checked="!!form.recargoFS" @change="$emit('set', 'recargoFS', $event.target.checked)">Fin de semana +{{ cfg.pctFS }}%</label>
        <label class="cdn-chk" :class="{ on: !!form.recargoNocturno }"><input type="checkbox" :checked="!!form.recargoNocturno" @change="$emit('set', 'recargoNocturno', $event.target.checked)">Horario nocturno +{{ cfg.pctNocturno }}%</label>
      </div>
      <p v-if="form.recargoFS || form.recargoNocturno" class="cdn-note">Los recargos van sobre el trabajo y los kilómetros, no sobre los gastos.<span v-if="form.recargoFS && form.recargoNocturno"> Son acumulables: {{ cfg.pctFS + cfg.pctNocturno }}%.</span></p>
    </CalcPanel>

    <CalcPanel titulo="Gastos" :pista="pistaGastos">
      <div v-if="sugerencia" class="cdn-state miss" style="margin-bottom:10px"><span class="ico">i</span><div><b>{{ sugerencia }}</b></div></div>
      <div class="cdn-two">
        <div>
          <div class="cdg-t"><b>1ª inspección</b></div>
          <div class="cdn-grid">
            <div class="cdn-f" v-for="g in gastos" :key="'g1' + g.k"><label :for="'cdn-' + g.k">{{ g.l }}</label><div class="cdn-unit"><input :id="'cdn-' + g.k" type="number" min="0" :value="form[g.k]" @input="num(g.k, $event)"><span>{{ g.u }}</span></div></div>
          </div>
        </div>
        <div v-if="tiene2a">
          <div class="cdg-t"><b>2ª inspección</b><button class="cdn-btn" type="button" @click="$emit('copiar')">Copiar de 1ª</button></div>
          <div class="cdn-grid">
            <div class="cdn-f" v-for="g in gastos" :key="'g2' + g.k"><label :for="'cdn-' + g.k + '2'">{{ g.l }}</label><div class="cdn-unit"><input :id="'cdn-' + g.k + '2'" type="number" min="0" :value="form[g.k + '2']" @input="num(g.k + '2', $event)"><span>{{ g.u }}</span></div></div>
          </div>
        </div>
      </div>
    </CalcPanel>
  </div>
</template>

<script>
import CalcPanel from './CalcPanel.vue';

/**
 * Desplazamiento, descuentos, recargos y gastos de las dos visitas: lo común a todas las
 * herramientas del motor, con los mismos campos del formulario que el diseño actual (`km`, `dto`,
 * `mismo`, `recargoFS`, `sub`/`sub2`…), para que lo guardado en una línea se reabra igual con
 * cualquiera de los dos diseños.
 */
export default {
  components: { CalcPanel },
  props: {
    form: { type: Object, required: true },
    cfg: { type: Object, required: true },
    kmmin: { type: Number, default: 0 },
    tiene2a: { type: Boolean, default: true },
    sugerencia: { type: String, default: '' }
  },
  data: function () {
    return {
      gastos: [
        { k: 'sub', l: 'Subcontratación', u: '€' },
        { k: 'peaj', l: 'Peajes y parking', u: '€' },
        { k: 'ncom', l: 'Comidas', u: 'ud' },
        { k: 'ncen', l: 'Cenas', u: 'ud' },
        { k: 'nhot', l: 'Hotel', u: 'noches' },
        { k: 'ndes', l: 'Desayunos', u: 'ud' }
      ]
    };
  },
  computed: {
    pistaKm: function () {
      const c = this.cfg;
      const coma = function (v) { return String(v).replace('.', ','); };
      return 'Mínimo ' + this.kmmin + ' km · ' + coma(c.tdf) + ' min/km · ' + coma(c.kmcost) + ' €/km';
    },
    pistaGastos: function () {
      const c = this.cfg;
      return 'Comida ' + c.com + ' € · cena ' + c.cen + ' € · hotel ' + c.hot + ' € · desayuno ' + c.des + ' €';
    }
  },
  methods: {
    num: function (campo, ev) {
      this.$emit('set', campo, parseFloat(ev.target.value) || 0);
    },
    /**
     * El descuento se teclea en tanto por ciento, como en la maqueta, pero el formulario lo sigue
     * guardando como MULTIPLICADOR (1 = sin descuento, 0,9 = un 10%), que es lo que leen el cálculo
     * de las demás herramientas, el PDF y las líneas de oferta ya guardadas.
     *
     * Tope en 99: un 100% sería un multiplicador 0, y el cálculo lee el 0 como «sin descuento» (el
     * `|| 1` de siempre). La casilla diría 100% y el precio saldría entero: el mismo defecto que dos
     * partes de la pantalla diciendo lo contrario.
     */
    pct: function (mult) {
      return Math.round((1 - (mult || 1)) * 10000) / 100;
    },
    dto: function (campo, ev) {
      const v = Math.min(Math.max(parseFloat(ev.target.value) || 0, 0), 99);
      this.$emit('set', campo, Math.round((1 - v / 100) * 10000) / 10000);
    }
  }
};
</script>

<style scoped>
.cdg{display:flex;flex-direction:column;gap:14px;min-width:0}
.cdg-t{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:8px;min-height:28px}
.cdg-t b{font-size:12.5px;color:var(--fg)}
</style>
